import { BusinessNumberDescriptionAu, fetchBusinessNumberDescription } from 'Hooks/Api/apiBusinessNumber';
import React, { createContext, useContext, useEffect, useState } from 'react';

// Create the context type
type BusinessNumberDescriptionContextType = {
	data: BusinessNumberDescriptionAu | null;
	loading: boolean;
	error: string | null;
};

// Default context value
const BusinessNumberDescriptionContext = createContext<BusinessNumberDescriptionContextType>({
	data: null,
	loading: true,
	error: null,
});

// Provider component
export const BusinessNumberDescriptionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [data, setData] = useState<BusinessNumberDescriptionAu | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await fetchBusinessNumberDescription();
				setData(res.data);
			} catch (err) {
				setError('Failed to load business descriptions');
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	const value: BusinessNumberDescriptionContextType = { data, loading, error }

	return (
		<BusinessNumberDescriptionContext.Provider value={value}>
			{children}
		</BusinessNumberDescriptionContext.Provider>
	);
};

// Hook to use the context
// const { data, loading, error } = useBusinessNumber();
export const useBusinessNumberDescription = () => useContext(BusinessNumberDescriptionContext);